// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"791030cf","78":"f86caa52","195":"2f3fc273","256":"5fbcfe03","268":"42f6a95f","444":"6914f0c0","476":"e2dcd27e","512":"b971eb0d","772":"acad16f2","792":"f1ab2b13","984":"b1e2f306"}[chunkId] + ".chunk.js";
};